/**
 * 带状区间趋势折线图验证配置
 * 为新 ValidationEngine 提供验证规则
 */

import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const bandedIntervalTrendLineValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: 'date', required: true },
    { field: 'y', type: 'number', required: true },
    { field: 'y2', type: 'number', required: true },
    { field: 'y3', type: 'number', required: true }
  ],
  businessRules: [
    {
      name: 'banded-interval-sufficient-data',
      validator: data => Array.isArray(data) && data.length >= 3,
      message:
        'Banded interval trend line requires at least 3 data points to show a meaningful trend',
      suggestion: 'Provide at least 3 data points for trend analysis',
      // 数据量建议，不影响图表渲染
      severity: 'warning'
    },
    {
      name: 'banded-interval-bounds-validation',
      validator: (data, layer) => {
        const { encoding } = layer;
        return (
          Array.isArray(data) &&
          data.every(item => {
            const y2Value = parseFloat(String(item[encoding?.y2 as string]));
            const y3Value = parseFloat(String(item[encoding?.y3 as string]));
            return y2Value >= y3Value;
          })
        );
      },
      message: 'Upper bound (y2) should be greater than or equal to lower bound (y3)',
      suggestion: 'Check your data to ensure y2 >= y3 for all data points',
      // 数据完整性验证，影响图表功能
      severity: 'error'
    }
  ]
};
